import React from 'react';
import styles from './PropertyTab.module.scss';
import globalStyles from 'common/global.module.scss';
import { Row } from 'antd';
import { FormField, maxLength } from 'common';
import {
  AddressFormFields,
  BlockLotFormFields,
  PropertyDocumentTypeFormFields,
} from 'pages/Search/templates';

const warnOwnerName = [maxLength(100)];

const PropertyTab: React.FC<{
  handleFieldFocus: any;
}> = ({ handleFieldFocus }) => {
  return (
    <>
      <PropertyDocumentTypeFormFields tabNamePrefix="propertyTab" />

      <FormField
        className={`m-0`}
        name="propertyTab.searchBy"
        inputType="radio"
        value="parcel"
      >
        Parcel
      </FormField>
      <BlockLotFormFields
        handleFieldFocus={handleFieldFocus}
        tabNamePrefix="propertyTab"
        rowStyle={globalStyles.row}
        inputStyle={globalStyles.input}
        startingTabIndex={100}
      />

      <FormField
        className={`m-0`}
        name="propertyTab.searchBy"
        inputType="radio"
        value="address"
      >
        Address
      </FormField>
      <AddressFormFields
        handleFieldFocus={handleFieldFocus}
        tabNamePrefix="propertyTab"
        rowStyle={globalStyles.row}
        inputStyle={globalStyles.input}
        startingTabIndex={400}
      />

      <FormField
        className={`m-0`}
        name="propertyTab.searchBy"
        inputType="radio"
        value="assessedOwner"
      >
        Assessed Owner
      </FormField>
      <Row type="flex" align="middle" className={globalStyles.row}>
        <FormField
          tabIndex="700"
          onFocus={handleFieldFocus}
          warn={warnOwnerName}
          label="Owner Name"
          name="propertyTab.ownerName"
          className={styles.owner}
        />
      </Row>
    </>
  );
};

export default React.memo(PropertyTab);
